export const BASE_ROUTES = {
  ROOT: "/",
  DASHBOARD: "/dashboard",
} as const;

export const BASE_URLS = {
  LOCALHOST: "http://localhost:3000",
} as const;

export const AUTH_ROUTES = {
  LOGIN: "/login",
  LOGIN_OTP: "/login-otp",
  FORGOT_PASSWORD: "/forgot-password",
  UPDATE_PASSWORD: "/update-password",
  CONFIRM: "/auth/confirm",
  ONBOARDING: "/onboarding",
  SUPPORT: "/support",
  MFA_VERIFY: "/mfa/verify",
  MFA_ENROLL: "/mfa/enroll",
} as const;

const ROUTE_NAMES = {
  ORDERS: "orders",
  INTEGRATIONS: "integrations",
  UPLOAD: "upload",
  PHONE: "phone",
  BILLING: "billing",
  NO_BILLING: "no-billing",
  NOT_FOUND: "not-found",
  WORKFLOWS: "workflows",
  STAFF: "staff",
  TOOLS: "tools",
  CREDENTIALS: "credentials",
  VARIABLES: "variables",
  CALLS: "calls",
  NUMBERS: "numbers",
  AGENTS: "agents",
  CAMPAIGNS: "campaigns",
  ANALYTICS: "analytics",
  TEMPLATES: "templates",
  KNOWLEDGE_BASE: "knowledge-base",
  MAKE_CALL: "make-call",
  AGENT_TEMPLATES: "agent-templates",
  AGENT: "agent",
  EVALS: "evals",
  LIVE: "live",
  CONFIGS: "configs",
  GENERATE: "generate",
  BATCH_RESULTS: "batch-results",
  RUNS: "runs",
  JOBS: "jobs",
  RESULTS: "results",
  QUICK_CALL: "quick-call",
  FORM: "form",
  SETTINGS: "settings",
  PHONE_ALERTS: "phone-alerts",
  QA: "qa",
  FEEDBACK: "feedback",
  API_REQUEST: "api-request",
  INTEGRATION: "integration",
  TRANSFER: "transfer",
  EDIT: "edit",
  TEAM: "team",
  API_TOKENS: "api-tokens",
  CHANGELOG: "changelog",
  CALL_CAPTURE_REVIEWS: "call-capture-reviews",
  SQUADS: "squads",
  VOICES: "voices",
} as const;

const VERBS = {
  CREATE: "create",
  EDIT: "edit",
} as const;

export const DASHBOARD_ROUTES = {
  ROOT: BASE_ROUTES.DASHBOARD,
  ORDERS: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.ORDERS}`,
    DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.ORDERS}/${id}`,
    UPLOAD: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.ORDERS}/${ROUTE_NAMES.UPLOAD}`,
  },
  PHONE: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}`,
    QUICK_CALL: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.QUICK_CALL}`,
    CALLS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.CALLS}`,
    NUMBERS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.NUMBERS}`,
    AGENTS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.AGENTS}`,
    AGENTS_CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.AGENTS}/${VERBS.CREATE}`,
    AGENTS_CREATE_FORM: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.AGENTS}/${VERBS.CREATE}/${ROUTE_NAMES.FORM}`,
    AGENTS_CREATE_FROM_TEMPLATE: (templateId: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.AGENTS}/${VERBS.CREATE}/${ROUTE_NAMES.FORM}/${templateId}`,
    AGENTS_CREATE_TEMPLATES: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.AGENTS}/${VERBS.CREATE}/${ROUTE_NAMES.TEMPLATES}`,
    AGENT_DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.AGENTS}/${id}`,
    CAMPAIGNS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.CAMPAIGNS}`,
    CAMPAIGN_CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.CAMPAIGNS}/${VERBS.CREATE}`,
    CAMPAIGN_DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.CAMPAIGNS}/${id}`,
    KNOWLEDGE_BASE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.KNOWLEDGE_BASE}`,
    KNOWLEDGE_BASE_CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.KNOWLEDGE_BASE}/${VERBS.CREATE}`,
    KNOWLEDGE_BASE_DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.KNOWLEDGE_BASE}/${id}`,
    CREDENTIALS: {
      ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.CREDENTIALS}`,
    },
    TOOLS: {
      ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.TOOLS}`,
      CREATE_API_REQUEST: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.TOOLS}/${VERBS.CREATE}/${ROUTE_NAMES.API_REQUEST}`,
      CREATE_INTEGRATION: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.TOOLS}/${VERBS.CREATE}/${ROUTE_NAMES.INTEGRATION}`,
      CREATE_TRANSFER: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.TOOLS}/${VERBS.CREATE}/${ROUTE_NAMES.TRANSFER}`,
      DETAIL: (id: string) =>
        `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.TOOLS}/${id}`,
    },
    VOICES: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.VOICES}`,
    WORKFLOWS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.WORKFLOWS}`,
    WORKFLOW_CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.WORKFLOWS}/${VERBS.CREATE}`,
    WORKFLOW_DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.WORKFLOWS}/${id}`,
    QA: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.QA}`,
    QA_DETAIL: (callId: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.QA}/${callId}`,
    FEEDBACK: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.FEEDBACK}`,
    SQUADS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.SQUADS}`,
    SQUADS_CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.SQUADS}/${VERBS.CREATE}`,
    SQUAD_DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.PHONE}/${ROUTE_NAMES.SQUADS}/${id}`,
  },
  BILLING: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.BILLING}`,
  },
  NO_BILLING: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.NO_BILLING}`,
  NOT_FOUND: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.NOT_FOUND}`,
  SETTINGS: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}`,
    CREDENTIALS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}/${ROUTE_NAMES.CREDENTIALS}`,
    VARIABLES: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}/${ROUTE_NAMES.VARIABLES}`,
    INTEGRATIONS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}/${ROUTE_NAMES.INTEGRATIONS}`,
    TEAM: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}/${ROUTE_NAMES.TEAM}`,
    API_TOKENS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}/${ROUTE_NAMES.API_TOKENS}`,
    PHONE_ALERTS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}/${ROUTE_NAMES.PHONE_ALERTS}`,
    CHANGELOG: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.SETTINGS}/${ROUTE_NAMES.CHANGELOG}`,
  },
} as const;

// Demo/Staff routes - separate section for demo purposes
export const DASHBOARD_STAFF_ROUTES = {
  ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}`,
  ANALYTICS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.ANALYTICS}`,
  INTEGRATIONS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.INTEGRATIONS}`,
  WORKFLOWS: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.WORKFLOWS}`,
    TEMPLATES: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.WORKFLOWS}/${ROUTE_NAMES.TEMPLATES}`,
    DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.WORKFLOWS}/${id}`,
  },
  AGENT_TEMPLATES: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.AGENT_TEMPLATES}`,
    CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.AGENT_TEMPLATES}/${VERBS.CREATE}`,
    DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.AGENT_TEMPLATES}/${id}`,
  },
  EVALS: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}`,
    CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${VERBS.CREATE}`,
    DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${id}`,
    RUN_DETAIL: (id: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.RUNS}/${id}`,
    BATCH_RESULTS: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.BATCH_RESULTS}`,
    GENERATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.GENERATE}`,
    GENERATE_JOB: (jobId: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.GENERATE}/${jobId}`,
    AGENT_DETAIL: (agentId: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.AGENT}/${agentId}`,
    LIVE: {
      ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.LIVE}`,
      CONFIG_CREATE: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.LIVE}/${ROUTE_NAMES.CONFIGS}/${VERBS.CREATE}`,
      CONFIG_DETAIL: (configId: string) =>
        `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.LIVE}/${ROUTE_NAMES.CONFIGS}/${configId}`,
      JOB_DETAIL: (jobId: string) =>
        `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.LIVE}/${ROUTE_NAMES.JOBS}/${jobId}`,
      RESULT_DETAIL: (resultId: string) =>
        `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.EVALS}/${ROUTE_NAMES.LIVE}/${ROUTE_NAMES.RESULTS}/${resultId}`,
    },
  },
  CALL_CAPTURE_REVIEWS: {
    ROOT: `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.CALL_CAPTURE_REVIEWS}`,
    DETAIL: (reviewId: string) =>
      `${BASE_ROUTES.DASHBOARD}/${ROUTE_NAMES.STAFF}/${ROUTE_NAMES.CALL_CAPTURE_REVIEWS}/${reviewId}`,
  },
} as const;

export const CHECKOUT_URLS = {
  /** Build success redirect URL for Stripe checkout. Appends checkout query params to the given URL. */
  success: (url: string) => {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}checkout=success&session_id={CHECKOUT_SESSION_ID}`;
  },
  /** Build cancel redirect URL for Stripe checkout. */
  cancel: (url: string) => `${url}?checkout=cancel`,
} as const;

// Routes accessible without authentication
export const UNAUTHENTICATED_ROUTES = [
  AUTH_ROUTES.LOGIN,
  AUTH_ROUTES.LOGIN_OTP, // Test-only OTP login page
  AUTH_ROUTES.FORGOT_PASSWORD,
  AUTH_ROUTES.UPDATE_PASSWORD, // Needed for password reset flow from email
  AUTH_ROUTES.CONFIRM, // Needed for email confirmation token exchange
  AUTH_ROUTES.SUPPORT, // Support page for users having trouble
] as const;

// Routes accessible at AAL1 (authenticated but MFA not yet verified)
export const MFA_ROUTES = [
  AUTH_ROUTES.MFA_VERIFY,
  AUTH_ROUTES.MFA_ENROLL,
  AUTH_ROUTES.ONBOARDING,
] as const;
